import { createSlice } from "@reduxjs/toolkit";
import { getSoldReports } from "./soldReportsAction";

interface SoldReport {
  _id: string;
  createdAt: string;
  vin: string;
  carOwnerName: string;
  email: string;
  carOwnerPhone: string;
  stock: string;
  policy: string;
  policyYear: number;
  price: string;
  dealerName: string;
  dealerJimiUserId: string;
  jimiUserId: string;
  vinNotInNhtsa: boolean;
}

interface SoldReportsState {
  data: SoldReport[];
  totalRecord: number;
  currentPage: number;
  totalPages: number;
  isLoading: boolean;
  isSuccess: boolean;
  responseCode: number | null;
  responseMessage: string;
  errorMessage: string;
}

const initialState: SoldReportsState = {
  data: [],
  totalRecord: 0,
  currentPage: 1,
  totalPages: 1,
  isLoading: false,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  errorMessage: ''
};

export const soldReportsList = createSlice({
  name: "soldReportsList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      // Get Sold Reports
      .addCase(getSoldReports.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getSoldReports.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data.reports || [];
        state.totalRecord = payload.data.pagination.total || 0;
        state.currentPage = payload.data.pagination.page || 1;
        state.totalPages = payload.data.pagination.pages || 1;
        state.isSuccess = true;
        state.responseCode = payload.responseCode;
        state.responseMessage = payload.responseMessage || '';
      })
      .addCase(getSoldReports.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload as string;
      });
  },
});

export default soldReportsList.reducer;
